import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MarketplaceFlagComponent } from "@front/m19-ui";
import { Marketplace } from "@front/m19-api-client";
import { NgClass } from "@angular/common";
import { TranslocoDirective } from "@jsverse/transloco";

export interface MarketplaceOption {
  marketplace: Marketplace;
  name: string;
  translationKey: string;
}

@Component({
  selector: "app-marketplace-option",
  imports: [MarketplaceFlagComponent, NgClass, TranslocoDirective],
  template: ` <div class="flex items-center gap-2 truncate text-sm text-gray-800" *transloco="let t">
    <IMarketplaceFlag [marketplace]="marketplace().marketplace" />
    <span class="font-medium" [ngClass]="{ 'hidden xl:inline': isLabel() }">{{ t(marketplace().translationKey) }}</span>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketplaceOptionComponent {
  marketplace = input.required<MarketplaceOption>();
  isLabel = input(false);
}
